import React from 'react'
import {GoogleOAuthProvider} from '@react-oauth/google'
import {Helmet, HelmetProvider} from 'react-helmet-async'
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'
import styled from 'styled-components'
import {RouteStack} from './routes'
import {ThemeProvider} from './themes'
import {getOAuthClientId} from './utils'
import {WindowProvider} from './windows'
import {SnackbarProvider} from './common/components'
import {REDUX_STORE, REDUX_PERSISTOR} from './lib/redux'
import {
  BanModalProvider,
  ModalOnHoldProvider,
  LogoutModalProvider,
  DownTimeModalProvider,
  ModalReprocessKycProvider,
  ModalMaintenanceProvider,
  ModalLimitedAccessProvider,
  ExplorePaginationProvider,
  ModalRoboyuLevelUpProvider,
  ModalPolicyUpdateProvider,
  ModalPortalGuestProvider,
} from './context'

import(/* webpackChunkName: 'RegisterSW' */ './register-sw')

const StyledRoot = styled.div`
  ${({theme}) => ({backgroundColor: theme.white_1})}
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100vw;
`

export default function App() {
  const userLanguage = window.navigator.language.substring(0, 2)

  return (
    <WindowProvider>
      <GoogleOAuthProvider clientId={getOAuthClientId()}>
        <HelmetProvider>
          <Provider store={REDUX_STORE}>
            <PersistGate persistor={REDUX_PERSISTOR}>
              <Helmet>
                {userLanguage === 'id' ? (
                  <meta
                    name="description"
                    content={
                      'FotoYu adalah platform marketplace dokumentasi personal, dengan teknologi privasi AI, yang mempertemukan Fotografer (kreator) dengan Yuser. FotoYu dilengkapi dengan fitur media sosial sebagai tempat berbagi konten dokumentasi kamu dengan teman. Siapapun. Dimanapun. Kapanpun.'
                    }
                  />
                ) : (
                  <meta
                    name="description"
                    content={
                      'FotoYu is a personal documentation marketplace platform with AI privacy technology that connects Fotographers (creators) with Yusers. FotoYu is also equipped with social media features for sharing documentation content with friends. Anyone. Anywhere. Anytime.'
                    }
                  />
                )}
              </Helmet>
              <ThemeProvider>
                <SnackbarProvider>
                  <ModalPortalGuestProvider>
                    <ModalPolicyUpdateProvider>
                      <ModalMaintenanceProvider>
                        <LogoutModalProvider>
                          <BanModalProvider>
                            <ModalOnHoldProvider>
                              <DownTimeModalProvider>
                                <ModalReprocessKycProvider>
                                  <ModalRoboyuLevelUpProvider>
                                    <ModalLimitedAccessProvider>
                                      <ExplorePaginationProvider>
                                        <StyledRoot>
                                          <RouteStack />
                                        </StyledRoot>
                                      </ExplorePaginationProvider>
                                    </ModalLimitedAccessProvider>
                                  </ModalRoboyuLevelUpProvider>
                                </ModalReprocessKycProvider>
                              </DownTimeModalProvider>
                            </ModalOnHoldProvider>
                          </BanModalProvider>
                        </LogoutModalProvider>
                      </ModalMaintenanceProvider>
                    </ModalPolicyUpdateProvider>
                  </ModalPortalGuestProvider>
                </SnackbarProvider>
              </ThemeProvider>
            </PersistGate>
          </Provider>
        </HelmetProvider>
      </GoogleOAuthProvider>
    </WindowProvider>
  )
}
